import React, { useEffect, useState } from "react";
import _ from "lodash";
import { GiCheckMark } from "react-icons/gi";
import { RxCross2 } from "react-icons/rx";
import { Badge, Row, Col } from "react-bootstrap";
import { Switch } from "antd";
import { useMsal } from "@azure/msal-react";
import { BsPencilFill } from "react-icons/bs";
import { MdOutlineContentCopy } from "react-icons/md";

const DetailsCard = (props) => {

  const { instance } = useMsal();
  const account = instance.getActiveAccount();

  const detailsdatareceveid = props.data;
  const detailsdata = [];
  detailsdata.push(detailsdatareceveid);
  const metricdata = props.metrics;
  const updateCertificatiion = (flag) => {
    props.updateCertificationDetails(flag);
  };

  return (
    <>
      {_.map(detailsdata, (de) => {
        return (
          <>
            <div>
              {" "}
              <div className="details__data1">
                {de.datasourceId && de.datasourceId?.length > 0 ? (
                  // <h3>Datasource: {de.datasourceId}</h3>
                  <div className="w-100">
                    <Row className="px-2 py-1">
                      <Col className="col-3 p-0">
                        <span className="details-label text-dark">
                          Datasource <b> : </b>
                        </span>
                      </Col>
                      <Col className=" col-8 p-0 text-dark">
                        <span>
                          {de.datasourceId}
                        </span>
                      </Col>
                    </Row>
                  </div>
                ) : (
                  ""
                )}

                {/* <h3>Name: {de.name}</h3> */}
                <div className="w-100">
                  <Row className="px-2 py-1">
                    <Col className="col-3 p-0">
                      <span className="details-label text-dark">
                        Name  <b> : </b>
                      </span>
                    </Col>
                    <Col className=" col-8 p-0 text-dark">
                      <span>
                        {de.name}
                      </span>
                    </Col>
                  </Row>
                </div>
                {/* <h3>Schema: {de.datasetSchema}</h3> */}
                <div className="w-100">
                  <Row className="px-2 py-1">
                    <Col className="col-3 p-0">
                      <span className="details-label text-dark">
                        Schema <b> : </b>
                      </span>
                    </Col>
                    <Col className=" col-8 p-0 text-dark">
                      <span>
                        {de.datasetSchema}
                      </span>
                    </Col>

                  </Row>
                </div>
                <div className="w-100">
                  <Row className="px-2 py-1">
                    <Col className="col-3 p-0">
                      {" "}
                      <span className="details-label text-dark">
                        {/* <h3> */}
                        Data Owner <b> : </b>
                        {/* </h3> */}
                      </span>
                    </Col>
                    <Col className="sales col-8 p-0">
                      {" "}
                      {de.owner && de.owner.toString()?.length > 0
                        ? de.owner &&
                        de.owner.map((ow, idx) => (
                          <Badge
                            bg="success"
                            className="badge detail-badges"
                            key={idx}
                          >
                            {ow}
                          </Badge>
                        ))
                        : ""}
                    </Col>
                    {!props.lineageNode ? (
                      <Col
                        className=" col-1 p-0"
                        name="tags"
                        onClick={() => props.showModal("owner")}
                      >
                        <BsPencilFill
                          name="tags"
                          className="stroke-2 details-edit-icon rounded border"
                        />
                      </Col>
                    ) : null}
                  </Row>
                </div>

                <div className="w-100">
                  <Row className="px-2 py-1">
                    <Col className="col-2 p-0 text-dark">
                      {" "}
                      <span className="details-label text-dark">
                        {/* <h3> */}
                        Tags <b> : </b>
                        {/* </h3> */}
                      </span>
                    </Col>
                    <Col className="sales col-9 p-0">
                      {" "}
                      {de.tags && de.tags.toString()?.length > 0
                        ? de.tags &&
                        de.tags.map((tag, idx) => (
                          <Badge
                            bg="success"
                            className="badge detail-badges"
                            key={idx}
                          >
                            {tag.tagName.toString()}
                          </Badge>
                        ))
                        : ""}
                    </Col>
                    {!props.lineageNode ? (
                      <Col
                        className=" col-1 p-0"
                        name="tags"
                        onClick={() => props.showModal("tags")}
                      >
                        <BsPencilFill
                          name="tags"
                          className="stroke-2 details-edit-icon rounded border"
                        />
                      </Col>
                    ) : null}
                  </Row>
                </div>
                <div className="w-100">
                  <Row className="px-2 py-1 text-dark">
                    <Col className="col-6 p-0">
                      {" "}
                      <span className="details-label">
                        {/* <h3> */}
                        Security classification <b> : </b>
                        {/* </h3> */}
                      </span>
                    </Col>
                    <Col className="sales col-5 p-0">
                      {" "}
                      {de.securityClassification &&
                        de.securityClassification?.length > 0
                        ? de.securityClassification &&
                        de.securityClassification.map((classification, idx) => {
                          // Commented as of now, will used in future
                          // let classificationlabel =
                          //   props.securityclassification?.find(
                          //     (x) => x.value === classification
                          //   );
                          return (
                            <Badge
                              bg="success"
                              className="badge detail-badges"
                              key={idx}
                            >
                              {classification?.replace("securityclassification.", "")}
                            </Badge>
                          );
                        })
                        : ""}
                    </Col>
                    {/* {(!props.lineageNode && props.editaccessflag) ? (<Col className=" col-1 p-0" name="securityClassification" onClick={() => props.showModal("securityClassification")}> */}
                    {(!props.lineageNode) ? (<Col className=" col-1 p-0" name="securityClassification" onClick={() => props.showModal("securityClassification")}>
                      <BsPencilFill name="tags" className="stroke-2 details-edit-icon rounded border" />
                    </Col>) : ""}
                  </Row>
                </div>
                <div className="w-100">
                  <Row className="px-2 py-1 text-dark">
                    <Col className="col-3 p-0"> <span className="details-label">
                      {/* <h3> */}
                      Sensitivity <b> : </b>
                      {/* </h3> */}
                    </span>
                    </Col>
                    <Col className="sales col-8 p-0">
                      {" "}
                      {de.sensitivity && de.sensitivity?.length > 0
                        ? de.sensitivity &&
                        de.sensitivity.map((sensitivity, idx) => {

                          // Commented for now, will be enabled when lable will added in api response
                          // let classificationlabel = props.sensitivity?.find(x => x.value === sensitivity)
                          return <Badge bg="success" className="badge detail-badges" key={idx}>
                            {sensitivity?.replace("securityclassification.", "")}
                          </Badge>
                        })
                        : ""}
                    </Col>
                    {/* {(!props.lineageNode && props.editaccessflag) ? (<Col className=" col-1 p-0" name="sensitivity" onClick={() => props.showModal("sensitivity")}> */}
                    {(!props.lineageNode) ? (<Col className=" col-1 p-0" name="sensitivity" onClick={() => props.showModal("sensitivity")}>
                      <BsPencilFill name="tags" className="stroke-2 details-edit-icon rounded border" />
                    </Col>) : ""}
                  </Row>
                </div>
                {detailsdatareceveid.producer === "pipedream" ?
                  "" : (
                    <h3>
                      Accessed in the last 1 month: {props.oneMonthUserVisitCount}
                    </h3>
                  )}

                <div className="w-100">
                  <Row className="px-2 py-1">
                    <Col className="col-3 p-0">
                      <span className="details-label text-dark">
                        Domain <b> : </b>
                      </span>
                    </Col>
                    <Col className=" col-8 p-0 text-dark">
                      {de.domains && de.domains.toString()?.length > 0 ? (
                        <span>{de.domains.toString()}</span>
                      ) : (
                        "")}
                    </Col>

                  </Row>
                </div>

                {/* <h3>
                  Domain: {" "}
                  {de.domains && de.domains.toString()?.length > 0 ? (
                    <span>{de.domains.toString()}</span>
                  ) : (
                    ""
                  )}
                </h3> */}
                {!props.lineageNode ? (
                  <div className="d-flex">
                    <h3>Certify Dataset <b> : </b> </h3>
                    <div>
                      <Switch
                        style={{
                          backgroundColor: props.certifiedetails?.certifiedFlag
                            ? "green"
                            : "",
                        }}
                        checkedChildren={<GiCheckMark />}
                        unCheckedChildren={<RxCross2 />}
                        checked={props.certifiedetails?.certifiedFlag}
                        onChange={updateCertificatiion}
                        loading={props.toggleloading}
                      />
                    </div>
                  </div>
                ) : null}
                {props.certifiedetails?.certifiedFlag ? (
                  <>
                    <h3>Certified by: {props.certifiedetails?.certifiedBy} </h3>
                    <h3>
                      Certified date (DD-MM-YYYY): {" "}
                      {props.certifiedetails?.certificationDate
                        ? props.certifiedetails.certificationDate
                          .replace(/T.*/, "")
                          .split("-")
                          .reverse()
                          .join("-")
                        : ""}{" "}
                    </h3>
                  </>
                ) : (
                  ""
                )}
                {(props.lineageNode) ? "" : (
                  <>
                    <h3>Last Modified : {de.lastModified}</h3>
                    <h3>Approximate Size: {de.approximateSize}</h3>
                    <h3>Row Count: {de.rowCount}</h3>
                  </>
                )}
                {detailsdatareceveid.producer === "pipedream" ? ""
                  : (
                    <div className="w-100">
                      <Row className="px-2 py-1">
                        <Col className="col-3 p-0">
                          {" "}
                          <span className="details-label">
                            <h3>AAD group names:</h3>
                          </span>
                        </Col>
                        <Col className="sales col-7 p-0">
                          {" "}
                          {de.aadGroupNames && de.aadGroupNames.toString()?.length > 0
                            ?
                            de.aadGroupNames.map((aadgroup, idx) => (
                              <>
                                <div className="d-flex">
                                  <div>
                                    <Badge
                                      bg="success"
                                      className="badge detail-badges"
                                      key={idx}
                                    >
                                      {aadgroup}
                                    </Badge>
                                  </div>
                                  <div className="addgroup-copy" onClick={() => props.copyAADgroups(aadgroup)}><MdOutlineContentCopy size={20} /></div>
                                </div>

                              </>
                            ))
                            : ""}

                        </Col >
                        {/* <Col className="addgroup-copy text-end">
                      <div onClick={() => props.copyAADgroups(de.aadGroupNames)}><MdOutlineContentCopy size={20} /></div>
                    </Col> */}

                      </Row>
                    </div>
                  )}

              </div>
              <br />
              {_.map(metricdata, (me) => {
                return (
                  <div className="metrics__data">
                    <h2>Metrics</h2>
                    <h3>Records: {me.metricValue}</h3>
                    <h3>Created: N/A</h3>
                    <h3>Updated: {me.updatedAt}</h3>
                  </div>
                );
              })}
            </div>
          </>
        );
      })}
    </>
  );
};

export default DetailsCard;
